import { c as _c } from "react/compiler-runtime";
import { Heading, HStack, Text, VStack } from '@chakra-ui/react';
import { useIsMobile } from '@src/components/sco/Advisors/hooks/useIsMobile';
import { ReactNode } from 'react';
export const SectionHeader = t0 => {
  const $ = _c(16);
  const {
    eyebrow,
    title,
    description,
    action
  } = t0;
  const isMobile = useIsMobile();
  const t1 = isMobile ? "wrap" : "nowrap";
  let t2;
  if ($[0] !== eyebrow) {
    t2 = eyebrow && <Text color="colorPalette.fg/60" textStyle="labelXs">{eyebrow}</Text>;
    $[0] = eyebrow;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isMobile ? "2xl" : "3xl";
  let t4;
  if ($[2] !== t3 || $[3] !== title) {
    t4 = <Heading size={t3}>{title}</Heading>;
    $[2] = t3;
    $[3] = title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== description || $[6] !== isMobile) {
    t5 = description && <Text color="colorPalette.fg/60" fontSize={isMobile ? "sm" : "md"} maxWidth="2xl">{description}</Text>;
    $[5] = description;
    $[6] = isMobile;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t4 || $[10] !== t5) {
    t6 = <VStack align="stretch" gap={2}>{t2}{t4}{t5}</VStack>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== action || $[13] !== t1 || $[14] !== t6) {
    t7 = <HStack align="flex-start" gap={4} justify="space-between" wrap={t1}>{t6}{action}</HStack>;
    $[12] = action;
    $[13] = t1;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};